"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var localized_strings_1 = require("localized-strings");
exports.lengthUnits = new localized_strings_1.default({
    en: {
        Centimeter: {
            AbbreviatedDisplay: 'cm',
            FullDisplay: 'centimeters'
        },
        Foot: {
            AbbreviatedDisplay: 'ft',
            FullDisplay: 'feet'
        },
        Inch: {
            AbbreviatedDisplay: 'in',
            FullDisplay: 'inches'
        },
        Kilometer: {
            AbbreviatedDisplay: 'km',
            FullDisplay: 'kilometers'
        },
        Meter: {
            AbbreviatedDisplay: 'm',
            FullDisplay: 'meters'
        },
        Mile: {
            AbbreviatedDisplay: 'mi',
            FullDisplay: 'miles'
        },
        Rod: {
            AbbreviatedDisplay: 'rod',
            FullDisplay: 'rods'
        }
    }
}, {
    logsEnabled: false
});
